import { Component, OnInit, OnDestroy, signal, computed, inject, DestroyRef } from '@angular/core';
import { characterCount, accordion } from "uswds/src/js/components";
import { LanguageService } from '@/common/services/language.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-ecorr-usa-banner',
    templateUrl: './ecorr-usa-banner.component.html',
    styleUrls: ['./ecorr-usa-banner.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        TranslateModule
    ]
})
export class EcorrUsaBannerComponent implements OnInit, OnDestroy {
    private destroyRef = inject(DestroyRef);
    private languageService = inject(LanguageService);

    // Signal-based state management
    ref = signal<any>(null);
    language = signal<string>('en');
    lockImgHtml = signal<string>('<span class="icon-lock" aria-hidden="true"><img class="icon-lock__img" src="./assets/img/icon-lock.svg" alt="" /></span>');

    // Computed properties
    currentLanguage = computed(() => this.language());

    constructor() { }

    ngOnInit(): void {
        // Initialize USWDS components
        if (this.ref()) {
            characterCount.on(this.ref());
        }
        accordion.on();

        // Subscribe to language changes with automatic cleanup
        this.languageService.language$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (res) => {
                    this.language.set(res.language);
                },
                error: (err) => {
                    console.error('Language service error:', err);
                }
            });
    }

    ngOnDestroy(): void {
        // Cleanup USWDS components
        if (this.ref()) {
            characterCount.off();
        }
        accordion.off();
    }
}